import { Card, Input, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useSimulation } from '../../context/SimulationContext';
import {
  REFLECTION_TEXT_MAX_LENGTH,
  REFLECTION_QUALITY_THRESHOLD,
} from '../../constants/simulation.constants';
import './ReflectionPanel.scss';

function ReflectionPanel() {
  const { reflectionText, dispatch } = useSimulation();
  const charCount = reflectionText.length;

  const extra =
    charCount > 0 && charCount < REFLECTION_QUALITY_THRESHOLD ? (
      <Typography.Text type="warning">
        {REFLECTION_QUALITY_THRESHOLD - charCount} more characters for a quality
        reflection
      </Typography.Text>
    ) : charCount >= REFLECTION_QUALITY_THRESHOLD ? (
      <Typography.Text type="success">
        <CheckCircleOutlined /> Quality reflection
      </Typography.Text>
    ) : null;

  return (
    <Card
      title="Reflection (Optional)"
      className="reflection-panel"
      size="small"
      extra={extra}
    >
      <Input.TextArea
        value={reflectionText}
        onChange={(e) =>
          dispatch({
            type: 'SET_REFLECTION_TEXT',
            payload: e.target.value,
          })
        }
        placeholder="What's your reasoning? Any risks, assumptions, or hypotheses?"
        rows={3}
        maxLength={REFLECTION_TEXT_MAX_LENGTH}
        showCount
      />
    </Card>
  );
}

export default ReflectionPanel;
